/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Social_Sign_In_With_GoogleInputs */

const en_auth_social_sign_in_with_google = /** @type {(inputs: Auth_Social_Sign_In_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In with Google`)
};

const es_auth_social_sign_in_with_google = /** @type {(inputs: Auth_Social_Sign_In_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesion con Google`)
};

/**
* | output |
* | --- |
* | "Sign In with Google" |
*
* @param {Auth_Social_Sign_In_With_GoogleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_social_sign_in_with_google = /** @type {((inputs?: Auth_Social_Sign_In_With_GoogleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Social_Sign_In_With_GoogleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_social_sign_in_with_google(inputs)
	return es_auth_social_sign_in_with_google(inputs)
});